export default function Intro() {
  return (
    <div className="section regular center intro" data-scroll-section>
      <div className="header-container">
        <h1>Food Insecurity and Migration</h1>
        <p className="subtitle">
          A Data Visualization Story in Northern Triangle Region of Central
          America
        </p>
      </div>
      <small>SCROLL TO CONTINUE</small>
    </div>
  );
}
